export { default } from './AllInclusiveCardSlider';
